import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import ConfirmationModal from "../../../shared/components/confirmationModal";
import GoalPlanFormContainer from "../shared/goalPlanForm/goalPlanFormContainer";
import { t, Trans } from "adapters/i18n";

const TEXT_BUTTON_SUBMIT = t("common:actions.save-edition");

const GoalPlanEditionPage = ({
  farmId,
  goalPlanId,
  onBack,
  onSubmit,
  enableLoading,
  disableLoading,
  notifyError,
  showConfirmationModal,
  classes,
}) => {
  const subtitle = () => (
    <Typography className={classes.subtitle}  data-testid="Goal-Plan-Edition-Subtitle">
      <Trans i18nKey="goalPlan:edit-plan-info" components={{ b: <b /> }} />
    </Typography>
  );

  return (
    <GoalPlanFormContainer
      farmId={farmId}
      titlePage={t("goalPlan:edit-plan")}
      titleContent=""
      subtitleContent={subtitle}
      onBack={onBack}
      onSubmit={onSubmit}
      enableLoading={enableLoading}
      disableLoading={disableLoading}
      notifyError={notifyError}
      initialDataPlanId={goalPlanId}
      disableEditTable
      textButtonSubmit={TEXT_BUTTON_SUBMIT}
    >
      {showConfirmationModal && (
        <ConfirmationModal
          title={showConfirmationModal.title}
          text={showConfirmationModal.text}
          submitButtonTitle={showConfirmationModal.buttonConfirmText}
          onSubmit={showConfirmationModal.onConfirm}
          onCancel={showConfirmationModal.onCancel}
        />
      )}
    </GoalPlanFormContainer>
  );
};

const styles = () => {
  return {
    title: {
      fontSize: "20px",
      color: "#444444",
    },
    subtitle: {
      fontSize: "16px",
      color: "#444444",
      paddingTop: "20px",
    },
  };
};

export default withStyles(styles)(GoalPlanEditionPage);
